import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import cx from 'classnames';

import {
  closeCompanyContactModal,
  openCompanyContactModal,
  reset,
  sendCompanyContactUsForm
} from '../../redux/modules/company';

import {
  hideMessageModal,
  openMessageModal
} from '../../redux/modules/messageModal';

import ShareButtonsRow from '../../components/ShareButtonsRow/ShareButtonsRow';
import checkRtlLanguage from '../../utils/checkRtlLanguage';
import HeaderPhones from '../../components/Company/HeaderPhones/HeaderPhones';
import ConsultationForm from '../../components/Company/ConsultationForm/ConsultationForm';

import * as styles from './RealtorsAssociationContainer.scss';

import makeSharingUrl from '../../utils/makeSharingUrl';

import {
  REALTORS_ASSOCIATION_NAME,
  REALTORS_ASSOCIATION_NAME_SHORT,
  REALTORS_ASSOCIATION_TITLE,
  REALTORS_ASSOCIATION_DESCRIPTION_TITLE,
  REALTORS_ASSOCIATION_LOGO,
  REALTORS_ASSOCIATION_DESCRIPTION_MAIN,
  REALTORS_ASSOCIATION_DESCRIPTION_ADVANTAGES,
  REALTORS_ASSOCIATION_EMAIL,
  REALTORS_ASSOCIATION_PHONE
} from './constants';

class RealtorsAssociationContainer extends Component {
  state = {
    captcha: null
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.formSubmitted && nextProps.formSubmitted) {
      this.props.reset();
      this.openSuccessMessage();
    }
  }

  fetchReCaptchaToken = (token) => {
    this.setState({ captcha: token });
  }

  openSuccessMessage = () => this.props.openMessageModal({
    message: (
      <div className="successMessage">
        <span>{this.props.translate('companyPage', 'contactsForm', 'submitting_success')}</span>
      </div>
    ),
    messageModalClassName: 'company-message-modal'
  });

  formConsultationSubmitHandler = formValues => {
    const { captcha } = this.state;

    this.props.sendCompanyContactUsForm({
      ...formValues,
      captcha,
      receiver_name: REALTORS_ASSOCIATION_NAME_SHORT,
      to: REALTORS_ASSOCIATION_EMAIL
    });
  };

  renderShareButton = () => {
    const sharingData = {
      sharingUrl: makeSharingUrl('/professionals/realtors-association', this.props.locale),
      sharingTitle: REALTORS_ASSOCIATION_NAME[this.props.locale]
    };

    return (
      <ShareButtonsRow
        isNative={this.props.isNative}
        sharingData={sharingData}
        isMobile={this.props.isMobile}
        locale={this.props.locale}
        copyLinkTitle={`${this.props.translate('copyLink')}`}
        shareTitle={`${this.props.translate('companyPage', 'shareTitle')}`}
        className="realtorsAssociation"
        isHideShareTitle
      />
    );
  };

  renderDescription = () => (
    <div className={styles.description}>
      <div className={styles.descriptionTitle}>{REALTORS_ASSOCIATION_TITLE[this.props.locale]}</div>
      <div className={styles.descriptionMain}>{REALTORS_ASSOCIATION_DESCRIPTION_MAIN[this.props.locale]}</div>
      <br />
      <div className={styles.descriptionTitle}>{REALTORS_ASSOCIATION_DESCRIPTION_TITLE[this.props.locale]}</div>
      <div className={styles.listBlock}>
        {REALTORS_ASSOCIATION_DESCRIPTION_ADVANTAGES.map((item) => (
          <li>
            <span className="icon icon-check" />
            {item[this.props.locale]}
          </li>
        ))}
      </div>
    </div>
  );

  renderConsultationForm = (companyName, className, field_id) => (
    <ConsultationForm
      fetchReCaptchaToken={this.fetchReCaptchaToken}
      locale={this.props.locale}
      field_id={field_id}
      companyName={companyName}
      className={className}
      translate={this.props.translate}
      onSubmit={this.formConsultationSubmitHandler}
      isRtl={this.props.isRtl}
      formSubmitting={this.props.formSubmitting}
      formSubmitted={this.props.formSubmitted}
      formConsultationError={this.props.formError}
    />
  );

  renderDesktopContent = () => (
    <div className={cx(styles.topWrap, styles.realtorsAssociationWrap)}>
      <span className={styles.bgCover} />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.logo}>
            <img src={REALTORS_ASSOCIATION_LOGO} alt="REALTORS_ASSOCIATION_LOGO" />
          </div>
          <div>
            <h1 className={styles.title}>{REALTORS_ASSOCIATION_NAME[this.props.locale]}</h1>
            <HeaderPhones
              translate={this.props.translate('companyPage')}
              phoneNumber={REALTORS_ASSOCIATION_PHONE}
              locale={this.props.locale}
              isMobile={this.props.isMobile}
              className="realtorsAssociationPhone"
            />
            <br />
            {this.renderConsultationForm(REALTORS_ASSOCIATION_NAME[this.props.locale], 'realtorsAssociationHeaderTopForm', 'realtor_association_name_form')}

            {this.renderShareButton()}
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    return (
      <div>
        {this.renderDesktopContent()}
        {this.renderDescription()}
      </div>
    );
  }
}

RealtorsAssociationContainer.propTypes = {
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  translate: PropTypes.func,
  formSubmitted: PropTypes.bool,
  formSubmitting: PropTypes.bool,
  formError: PropTypes.object,
  isModalShareOpen: PropTypes.bool,
  location: PropTypes.object,
  sendCompanyContactUsForm: PropTypes.func,
  openMessageModal: PropTypes.func,
  reset: PropTypes.func,
  isRtl: PropTypes.bool,
  isNative: PropTypes.bool
};

const mapStateToProps = (state) => ({
  locale: state.lang.locale,
  isRtl: checkRtlLanguage(state.lang.locale),
  isMobile: state.windowDimentions.isMobile,
  translate: getLang(state.lang, 'static'),
  formSubmitted: state.company.formSubmitted,
  formSubmitting: state.company.formSubmitting,
  formError: state.company.formError,
  isNative: state.native.isNative,
  isModalShareOpen: state.shareModal.isModalShareOpen
});

const mapDispatchToProps = {
  openCompanyContactModal,
  closeCompanyContactModal,
  sendCompanyContactUsForm,
  openMessageModal,
  hideMessageModal,
  reset
};

export default connect(mapStateToProps, mapDispatchToProps)(RealtorsAssociationContainer);
